var exports = {
  "kD": "OrganizationPropertyIncludeIcon__wvu0Sa",
  "KZ": "OrganizationPropertyExcludeIcon__KoVZ3A",
};

module.exports = exports;
